import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { demoMode } from './api';
import { subscribeDemoBookings } from './demoEvents';

// Живое обновление записей.
// Демо: вкладка владельца подписана на изменения localStorage/BroadcastChannel
// и перезапрашивает список, когда клиент записался в другой вкладке.
// Прод: Cloudflare Pages Functions — это обычный fetch, без websocket-канала,
// поэтому обновляем список опросом раз в 20 секунд, пока открыт кабинет.
// Дешёвый D1-запрос; Realtime не нужен и не тянет лишние зависимости.
export function useLiveBookings(): void {
  const qc = useQueryClient();

  useEffect(() => {
    if (demoMode) {
      return subscribeDemoBookings(() => {
        void qc.invalidateQueries({ queryKey: ['owner-bookings'] });
        void qc.invalidateQueries({ queryKey: ['my-bookings'] });
        void qc.invalidateQueries({ queryKey: ['slots'] });
      });
    }

    const tick = () => {
      void qc.invalidateQueries({ queryKey: ['owner-bookings'] });
      void qc.invalidateQueries({ queryKey: ['my-bookings'] });
      void qc.invalidateQueries({ queryKey: ['slots'] });
    };

    const id = window.setInterval(tick, 20_000);
    return () => window.clearInterval(id);
  }, [qc]);
}
